import { render, staticRenderFns } from "./LoginOverlay.vue?vue&type=template&id=2ca1a5b6&scoped=true"
import script from "./LoginOverlay.vue?vue&type=script&lang=js"
export * from "./LoginOverlay.vue?vue&type=script&lang=js"
import style0 from "./LoginOverlay.vue?vue&type=style&index=0&id=2ca1a5b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca1a5b6",
  null
  
)

export default component.exports